/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SAMLChallengeOptions } from './SAMLChallengeOptions';
import {
    SAMLChallengeOptionsFromJSON,
    SAMLChallengeOptionsFromJSONTyped,
    SAMLChallengeOptionsToJSON,
} from './SAMLChallengeOptions';

/**
 * 
 * @export
 * @interface SAMLChallengeAllOf
 */
export interface SAMLChallengeAllOf {
    /**
     * 
     * @type {SAMLChallengeOptions}
     * @memberof SAMLChallengeAllOf
     */
    options: SAMLChallengeOptions;
}

/**
 * Check if a given object implements the SAMLChallengeAllOf interface.
 */
export function instanceOfSAMLChallengeAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function SAMLChallengeAllOfFromJSON(json: any): SAMLChallengeAllOf {
    return SAMLChallengeAllOfFromJSONTyped(json, false);
}

export function SAMLChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': SAMLChallengeOptionsFromJSON(json['options']),
    };
}

export function SAMLChallengeAllOfToJSON(value?: SAMLChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': SAMLChallengeOptionsToJSON(value.options),
    };
}

